export type ReturnReason = {
  parentReason: Reason
  subReasons: Reason[]
}

export type Reason = {
  reason: string
  categoryIds: string[]
  hidden: boolean
  mandatoryComment: boolean
}

// A reason with its position in the stored list, which the editor's handlers address it by.
export interface DashboardReason extends ReturnReason {
  index: number
}

// The Return reasons tab: the reasons, and their order, which is stored with the return conditions.
export interface ReturnReasonsSettings {
  reasons: ReturnReason[]
  // Undefined while the group has no return conditions, where the order setting lives.
  randomizeOrder?: boolean
}

const applies = (reason: Reason) => reason.categoryIds.some(Boolean)

// The codes a return can carry, as settings-api's FindAllByCategoryID shows them: a reason with
// sub-reasons is only a heading, so its sub-reasons are offered, under it or alone when it is hidden.
export function activeReasonCodes(reasons: ReturnReason[]): string[] {
  const codes = reasons.flatMap(({ parentReason, subReasons }) => {
    const shown = !parentReason.hidden && applies(parentReason)
    if (subReasons.length === 0) return shown ? [parentReason.reason] : []
    return shown || parentReason.hidden
      ? subReasons.filter(applies).map((sub) => sub.reason)
      : []
  })
  return [...new Set(codes)]
}
